import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyVisitsSwitch, recordPageView } from '@/lib/visits';

/** Counts each page shown for the admin's "Visitas" view (lib/visits.ts). The admin panel never renders it. */
export default function VisitTracker() {
  const { pathname } = useLocation();
  useEffect(() => { applyVisitsSwitch(); }, []);
  // The full address, with its language prefix (/es/escunas): switching language is not a new page.
  useEffect(() => { recordPageView(window.location.pathname); }, [pathname]);
  return null;
}
